import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Filter } from '@brafton/angular-framework-library';
import { ProductsService, OrganizationsService } from '@brafton/atlas-api-client';
import { ProductClass } from '@brafton/common-framework-library';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'shared-filter-panel-industry-sectors',
  templateUrl: './filter-panel-industry-sectors.component.html',
  styleUrls: ['./filter-panel-industry-sectors.component.scss'],
  host: { class: 'filter-panel-industry-sectors' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SharedFilterPanelIndustrySectorsComponent implements OnInit {
  @Input() industrySectors: Filter[] = [];
  @Output() industrySectorsChange: EventEmitter<Filter[]> = new EventEmitter<Filter[]>();
  @Output() close: EventEmitter<any> = new EventEmitter();

  sectors$!: Observable<string[]>;
  subSectors$!: Observable<string[]>;

  constructor(private organizationsService: OrganizationsService) {}

  ngOnInit() {
    this.sectors$ = this.organizationsService
      .listSalesforceIndustryCategories()
      .pipe(map((i: string[]) => i.sort((a, b) => a.localeCompare(b))));
    this.subSectors$ = this.organizationsService
      .listSalesforceSubIndustryCategories()
      .pipe(map((i: string[]) => i.sort((a, b) => a.localeCompare(b))));
  }

  filterSubSectors(subSectors: string[] | null, sector?: string): string[] | undefined {
    if (!subSectors) return;
    const r = subSectors.filter((ss) => ss.startsWith(sector + ' - '));
    return r;
  }

  selectedSector(): string | undefined {
    if (this.industrySectors.length === 0) return;

    if (this.industrySectors[0].value.includes(' - ')) {
      return this.industrySectors[0].value.split(' - ')[0];
    } else {
      return this.industrySectors[0].value;
    }
  }

  addProduct(sector: string) {
    this.clear();
    if (!this.industrySectors.find((sp) => sp.value === sector)) {
      this.industrySectors.push({ value: sector, displayName: sector, type: 'industry-sector' } as Filter);
    }
    this.industrySectorsChange.emit(this.industrySectors);
  }

  removeProduct(sector: string) {
    const index = this.industrySectors.findIndex((sp) => sp.value === sector);
    if (index > -1) {
      this.industrySectors.splice(index, 1);
    }
    this.industrySectorsChange.emit(this.industrySectors);
  }

  clear() {
    this.industrySectors = [];
    this.industrySectorsChange.emit(this.industrySectors);
  }

  isSelected(sector: string): boolean {
    if (!this.industrySectors) return false;
    if (this.industrySectors.find((sp) => sp.value === sector || sp.value.split(' - ')[0] === sector)) return true;
    else return false;
  }
}
